// extracted by mini-css-extract-plugin
export default {"follow-btn":"UserFollowBtn_follow-btn__MYT4e","following-btn":"UserFollowBtn_following-btn__4ti6h"};